<template lang="pug">
b-modal#modal-overlay-image-script(title='貼り付け用タグを取得')
  .callout.callout-info
    p
      | 以下のタグを、オーバーレイを表示したいWebページに設置してください。
      br/
      | Webページのbody内に設置した場合、該当Webページのみ、head内に設置した場合、headを共有している全てのWebページでオーバーレイが表示されます。
      br/
      | また、「特定位置出現」を選択された場合、Webページbody内の、スクロールした際に出現させたい位置に設置してください。
      br/
      | タグ設置方法は
      a(class="text-primary", href="https://docs.google.com/presentation/d/1KpAYhUqPNecSY-hVYmDiLVE6omAjmDcQspgZnOYY988/edit?usp=sharing", target="_blank") こちら
      | をご参照ください。
  .row
    textarea.form-control(v-if="$store.state.overlay.specific_position_flag", rows=5)
      | <div id="overlay_image_{{$store.state.overlay.token}}"></div><script type="text/javascript" charset="utf-8" src="{{$store.state.overlay.url}}"></script>
    textarea.form-control(v-else, rows=5)
      | <script type="text/javascript" charset="utf-8" src="{{$store.state.overlay.url}}"></script>
</template>

<script>
import Vue from 'vue'

export default {
  methods: {
  },
  components: {
  },
  async mounted(){
    await Vue.nextTick()
  },
}
</script>
<style lang="scss" scoped>
</style>
